export default __webpack_public_path__ + "static/media/help.bda1d347.svg";